(function() {
  'use strict';
  
  const FIELD_CONTAINER_SELECTOR = '[data-participant-fields]';
  const FIELD_NAME_PREFIX = 'Nome e Cognome ';
  const FIELD_PLACEHOLDER_PREFIX = 'Partecipante ';
  const START_INDEX = 2;
  
  function init() {
    const container = document.querySelector(FIELD_CONTAINER_SELECTOR);
    if (!container) return;
    
    const quantityInputElement = document.querySelector('quantity-input');
    if (!quantityInputElement) return;
    
    const quantityInput = quantityInputElement.querySelector('input');
    if (!quantityInput) return;
    
    updateParticipantFields(container, quantityInput);
    
    quantityInput.addEventListener('change', function() {
      updateParticipantFields(container, quantityInput);
    });
    
    quantityInput.addEventListener('input', function() {
      updateParticipantFields(container, quantityInput);
    });
    
    const buttons = quantityInputElement.querySelectorAll('button');
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        setTimeout(function() {
          updateParticipantFields(container, quantityInput);
        }, 100);
      });
    });
    
    setupFormValidation(container);
  }
  
  function setupFormValidation(container) {
    const form = container.closest('form');
    if (!form) return;
    
    form.addEventListener('submit', function(e) {
      if (!validateParticipantFields(container)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Per favore, compila tutti i campi dei partecipanti prima di procedere.');
        return false;
      }
    }, true);
    
    const addToCartButton = form.querySelector('button[type="submit"][name="add"]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function(e) {
        if (!validateParticipantFields(container)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Per favore, compila tutti i campi dei partecipanti prima di procedere.');
          return false;
        }
      }, true);
    }
    
    const paymentButtonContainer = form.querySelector('.shopify-payment-button');
    if (paymentButtonContainer) {
      paymentButtonContainer.addEventListener('click', function(e) {
        if (!validateParticipantFields(container)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Per favore, compila tutti i campi dei partecipanti prima di procedere.');
          return false;
        }
      }, true);
    }
  }
  
  function updateParticipantFields(container, quantityInput) {
    const currentQuantity = parseInt(quantityInput.value) || 1;
    const wrapper = document.querySelector('[data-participant-wrapper]');
    
    if (currentQuantity < START_INDEX) {
      container.innerHTML = '';
      if (wrapper) wrapper.style.display = 'none';
      return;
    }
    
    if (wrapper) wrapper.style.display = 'block';
    
    const existingValues = getExistingFieldValues(container);
    container.innerHTML = '';
    
    for (let i = START_INDEX; i <= currentQuantity; i++) {
      const fieldHTML = createParticipantField(i, existingValues[i] || '');
      container.insertAdjacentHTML('beforeend', fieldHTML);
    }
  }
  
  function getExistingFieldValues(container) {
    const values = {};
    const existingInputs = container.querySelectorAll('.participant-field__input');
    existingInputs.forEach(function(input) {
      const match = input.id.match(/participant-field-(\d+)/);
      if (match) values[parseInt(match[1])] = input.value;
    });
    return values;
  }
  
  function createParticipantField(index, value) {
    const fieldId = 'participant-field-' + index;
    const fieldName = 'properties[' + FIELD_NAME_PREFIX + index + ']';
    const placeholder = FIELD_PLACEHOLDER_PREFIX + index;
    
    return '<div class="field">' +
      '<input type="text" id="' + fieldId + '" name="' + fieldName + '" ' +
      'class="field__input participant-field__input" placeholder="' + placeholder + '" ' +
      'value="' + escapeHtml(value) + '" required autocomplete="off" />' +
      '<label class="field__label" for="' + fieldId + '">' + placeholder + '</label>' +
    '</div>';
  }
  
  function validateParticipantFields(container) {
    const inputs = container.querySelectorAll('.participant-field__input');
    if (inputs.length === 0) return true;
    
    let allValid = true;
    let firstInvalid = null;
    
    inputs.forEach(function(input) {
      if (!input.value.trim()) {
        allValid = false;
        if (!firstInvalid) firstInvalid = input;
      }
    });
    
    if (!allValid && firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    
    return allValid;
  }
  
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 150);
    });
  } else {
    setTimeout(init, 150);
  }
})();
